/* eslint-disable no-useless-escape */
/* eslint-disable no-shadow */
import React, {
  useState,
} from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
} from 'antd';
import {
  SpButton,
} from 'components/DesignKit';
import { businessActions, notificationActions } from 'store/actions';
import { API_END_POINTS, axiosAuthInstance } from 'api';
import { NOTIFICATION } from 'store/actionTypes';
import { InfoCircleOutlined, SyncOutlined } from '@ant-design/icons';

type Props = {
  selectedAccount: Object,
  setNotification: Function,
  fetchPaypalVerification: Function,
};

const VerificationProcess = (props: Props) => {
  const {
    selectedAccount,
    setNotification,
    fetchPaypalVerification,
  } = props;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const parseException = (exception) => {
    try {
      const parsed = JSON.parse(exception);
      return { isJson: true, parsed };
    } catch (e) {
      return { isJson: false, raw: exception };
    }
  };

  const onClickVerification = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const { data: { responseCode, status } } = await axiosAuthInstance.post(`internal${API_END_POINTS.PAYPAL}/${selectedAccount?.gid}/boarding`);
      if (responseCode === 201 && status === 'SUCCESS') {
        setNotification({
          type: NOTIFICATION.SUCCESS,
          payload: 'PayPal account verified successfully.',
        });
        fetchPaypalVerification(selectedAccount?.gid);
      }
    } catch (e) {
      const result = parseException(e.response.data && e.response.data.exception);
      if (result.isJson) {
        setError(result?.parsed);
      } else {
        setNotification({
          type: NOTIFICATION.ERROR,
          payload: result.raw,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="mx-auto mt-5 py-3 px-3"
      style={{ width: 1000, height: 'auto' }}
      bodyStyle={{ height: '100%' }}
    >
      <div
        style={{
          backgroundColor: '#FFF', padding: '25px', marginTop: '-15px', borderRadius: '10px',
        }}
      >
        <Row type="flex" justify="center" align="middle" gutter={[16, 16]}>
          <Col>
            <SpButton
              type="primary"
              shape="round"
              onClick={onClickVerification}
              icon={loading ? <SyncOutlined spin /> : null}
              loading={loading}
            >
              Board Paypal
            </SpButton>
          </Col>
        </Row>
        {error && (
          <Row type="flex" justify="center" align="middle" gutter={[16, 16]} className="mt-2">
            <Col>
              <div
                style={{
                  padding: '16px', border: '1px solid #ffe58f', borderRadius: '8px', backgroundColor: 'rgb(255 251 230)',
                }}
              >
                <h6><InfoCircleOutlined style={{ color: '#FADB14', fontSize: '20px' }} className="mb-1" /> Error: {error.name}</h6>
                <p><strong>Message:</strong> {error.message}</p>
                {error.debugId && <p><strong>Debug ID:</strong> {error.debugId}</p>}

                {error.details?.length > 0 && (
                  <div>
                    <h6>Details:</h6>
                    <ul>
                      {error.details.map((detail, idx) => (
                        <li key={idx}>
                          <strong>Field:</strong> {detail.field} <br />
                          <strong>Issue:</strong> {detail.issue} <br />
                          {detail.location && <><strong>Location:</strong> {detail.location}</>}
                        </li>
                      ))}
                    </ul>
                  </div>
              )}
              </div>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  selectedAccount: state.account.selectedAccount,
  test: state.account.test,
  isSuperUser: state.user.superUser,
  validator: state.loading.validator,
  paypalVerification: state.business.paypalVerification,
  submitting: state.loading.submitting,
});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  fetchPaypalVerification: gid => dispatch(businessActions.fetchPaypalVerification({
    payload: gid,
  })),
});

// $FlowFixMe
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VerificationProcess);
